import {FieldError} from "ch3-ui-lib";

interface Props {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    maxLength?: number;
    error?: string | null;
    phqId?: string;
    minHeightClassName?: string;
    labelClassName?: string;
}

export const EnsTextareaField = ({
    label,
    value,
    onChange,
    placeholder,
    maxLength,
    error,
    phqId,
    minHeightClassName = 'min-h-[84px]',
    labelClassName = 'text-sm font-semibold text-ink',
}: Props) => (
    <div className="w-full min-w-0">
        <div className="mb-1.5 flex w-full min-w-0 items-center justify-between gap-3">
            <label className={labelClassName}>{label}</label>
            {maxLength != null && (
                <span className={`shrink-0 text-xs ${error ? 'text-danger-ink' : 'text-ink-muted'}`}>
                    {value.length}/{maxLength} characters
                </span>
            )}
        </div>
        <textarea
            phq-id={phqId}
            placeholder={placeholder}
            value={value}
            maxLength={maxLength}
            aria-invalid={Boolean(error)}
            onChange={(event) => onChange(event.target.value)}
            className={`${minHeightClassName} w-full resize-none rounded-lg border px-3 py-2 text-sm leading-5 text-ink outline-none transition-colors placeholder:text-ink-disabled hover:border-brand-focus focus:border-brand focus:ring-0 ${
                error ? 'border-danger-ink' : 'border-line'
            }`}
        />
        <FieldError error={error}/>
    </div>
);
